import { Component, OnInit, ViewChild } from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import { Globals } from '../../../services/tools/Globals.service';
import { NgbDropdownConfig } from '@ng-bootstrap/ng-bootstrap';
/*App imports*/
import { CreditosService } from "../../../services/creditos.service";
import { HelpersService } from '../../../services/tools/helpers.service';
import { CreditosHipotecariosService } from "../../../services/creditos-hipotecarios.service";
import { TablaPagosComponent } from '../../components/tabla-pagos/tabla-pagos.component';

@Component({
  selector: 'app-hipotecario-detalles',
  templateUrl: './hipotecario-detalles.component.html',
  providers: [NgbDropdownConfig]
})
export class HipoteacrioDetallesComponent implements OnInit {
  @ViewChild('tablaPagos') tablaPagos: TablaPagosComponent;

  public errors:any = {};
  //Helpers
  private sub: any;
  public id: number = null;
  //UI vars
  public credito : any = { cliente : {}, prestamo : {}, sucursal : {} };
  public sectionStatus : any = {};
  public isEditable : boolean = false;
  public isInitialized : boolean = false;

  constructor(
    private globals: Globals, config: NgbDropdownConfig,
    private route: ActivatedRoute,
    private creditosService: CreditosService,
    private helperService: HelpersService,
    private hipotecariosService: CreditosHipotecariosService
    ){
    config.placement = 'bottom-right';
   }

  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
        this.id = +params['id'];// (+) converts string 'id' to a number
  
        //Fill Credito data
        this.getCredito(this.id);
        this.checkSectionsStatus();
        //Después de que cargan todos los elementos marco el componente como inicializado. 
        //Esto arregla un issue que había, ya que obligaba a que algunos comententes hcieran requests de créditos que se visualizaron anteriormente.
        this.isInitialized = true;
      });
  }

  private getCredito(idCreditos : number){
    //TODO: Manejar cuando el id no retorna un crédito valido
    this.creditosService.get(idCreditos).subscribe(
      (response)=>
      {
        const credito = response.json().content;
        this.credito = credito;

        //Los créditos en estatus pendiente deben mostrarse en modo Editable
        if(credito.statusCredito === 1){
          this.isEditable = true;
        }
        
      }, error =>
      {
        // se resuelve error 403 y 500
        this.helperService.httpGlobalError(error);

        if(error.status == 400) {
          this.setBackendErrors(error.json().content);
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }

  public checkSectionsStatus(){

    //Avisar a los demás componentes que hubo algún cambio en la información del crédito
    if(this.isInitialized){
      this.creditosService.reloadCreditoStatus();
    }

    this.creditosService.validateSections(this.id).subscribe(
      (response)=>
      {
        this.sectionStatus = response.json().content;    
      }, error =>
      {
        // se resuelve error 403 y 500
        this.helperService.httpGlobalError(error);

        if(error.status == 400) {
          this.setBackendErrors(error.json().content);
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }

  public updatedFechaContrato(nuevaFechaContrato){
    //Si se modifico la fecha de inicio del crédito, se debe recargar la tabla de pagos 
    //para calcularla con base en esta nueva fecha
    this.tablaPagos.reloadTablaPagos();
  }

  /**
   * Helpers
   */

  setBackendErrors(errors:any[]){
    let temp_errors = [];
    
    Object.keys(errors).forEach(function(key){
      temp_errors[key] = errors[key][0];
    });

    this.errors = temp_errors;
  }
    
}



// WEBPACK FOOTER //
// ./src/app/creditos/hipotecario/detalles/hipotecario-detalles.component.ts